export const getCaptionsState = (state) => state.captions;
export const getCaptions = (state) => getCaptionsState(state).captions;
export const getIsCaptionsOpen = (state) => getCaptionsState(state).isCaptionsOpen;
